import React, { useEffect } from 'react'
import Hero from '../composant/NaveHero/Hero'
import NaveBar from '../composant/NaveHero/NaveBar'
import ServicesSection from '../composant/ServicesSection'
import TeamSection from '../composant/TeamSection'
import Footer from '../composant/Footer'
import AboutSection0 from '../composant/AboutSection0'
import Counter from '../composant/Counter'
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2'


const Home = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div>
       <NaveBar />
       <Hero />
       <AboutSection0 />
       <Counter />
       <ServicesSection />
       <TeamSection />
       <MainContainerAdhesion2 />

       <Footer />
    </div>
  )
}

export default Home
